import React from "react";
import { motion } from "framer-motion";
import { ARTIST_PORTRAIT } from "../../lib/site-data";

export const About = () => {
    return (
        <section id="about" data-testid="about-section" className="py-24 sm:py-32 relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    className="lg:col-span-5 relative"
                >
                    <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden">
                        <img src={ARTIST_PORTRAIT} alt="Glow Momentz artist at her live event setup" className="w-full h-full object-cover" />
                        <div className="absolute inset-0 holo-bg mix-blend-overlay" />
                    </div>
                    <div className="absolute -bottom-6 -right-4 sm:-right-8 glass rounded-2xl p-5 max-w-[220px] shadow-xl">
                        <div className="font-display text-3xl text-brand-ink leading-none">Since 2016</div>
                        <p className="text-xs text-brand-inkSoft mt-2 leading-relaxed">
                            Sketching, painting, and sparkling across the Bay — one moment at a time.
                        </p>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="lg:col-span-7"
                >
                    <p className="text-xs tracking-[0.25em] uppercase text-brand-coral mb-4">Our story</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1.05] mb-3 text-balance">
                        Meet <em className="text-brand-coral">Payal</em>.
                    </h2>
                    <p className="font-display italic text-brand-inkSoft text-xl mb-7">
                        Turning moments into memories.
                    </p>
                    <div className="space-y-5 text-brand-inkSoft text-lg leading-relaxed font-light max-w-2xl">
                        <p>
                            Meet Payal, the founder of Glow Momentz — the hand behind an extraordinary henna
                            service specializing in events and now henna-inspired temporary tattoos.
                        </p>
                        <p>
                            Henna is an art that grew on her since she was 10 years old. With a passion for
                            craft and a deep appreciation for cultural traditions, Payal's expertise lies in
                            traditional and modern floral henna designs. Payal has provided henna for numerous
                            events, private appointments and much more.
                        </p>
                        <p className="font-display italic text-brand-ink text-xl leading-snug">
                            Experience the elegance of henna with Glow Momentz — where beauty and creativity
                            unite in breathtaking harmony.
                        </p>
                    </div>

                    <div className="mt-10 grid grid-cols-2 sm:grid-cols-2 gap-6">
                        {[
                            ["Pittsburg-based", "Travel across the Bay · $0.70/mile"],
                            ["Body-safe always", "Natural henna · FDA-compliant paints"],
                        ].map(([t, d]) => (
                            <div key={t} className="border-t border-brand-border pt-4">
                                <div className="font-display text-xl text-brand-ink">{t}</div>
                                <p className="text-sm text-brand-inkSoft mt-1">{d}</p>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default About;
